import PropTypes from 'prop-types';
import React from 'react';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { Link } from '@bibliocommons/base-links';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { truncate } from '@bibliocommons/utils-string';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bibEventComposer } from '@bibliocommons/analytics-event-composers';
import AnalyticsConstants from '@bibliocommons/constants-analytics';

const { composeTitleClickEvent } = bibEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

export class BibTitle extends React.PureComponent {
  handleClick = () => {
    const { reciprocalRank, catalogBib } = this.props;
    sendAnalyticsEvents(
      composeTitleClickEvent({
        containerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ITEM,
        reciprocalRank,
        metadataId: catalogBib.get('metadataId')
      })
    );
  };

  renderTitle() {
    const { catalogBib, renderAsLink, truncateCount } = this.props;
    const catalogBibBrief = catalogBib.get('brief');
    const title = catalogBibBrief.get('title');
    const otherScriptTitle = catalogBibBrief.get('otherScriptTitle');
    const truncatedTitle = truncateCount && title ? truncate(title, { desiredLength: truncateCount }) : title;
    const truncatedScriptTitle =
      truncateCount && otherScriptTitle
        ? truncate(otherScriptTitle, { desiredLength: truncateCount })
        : otherScriptTitle;

    const content = (
      <span>
        <span aria-hidden>
          {!!truncatedScriptTitle && <div>{truncatedScriptTitle}</div>}
          {truncatedTitle}
        </span>
        <ScreenReaderMessage>
          {otherScriptTitle} {title}
        </ScreenReaderMessage>
      </span>
    );

    if (renderAsLink) {
      return (
        <Link
          href={`/v2/record/${catalogBib.get('metadataId')}`}
          dataKey="bib-title-link"
          handleClick={this.handleClick}
        >
          {content}
        </Link>
      );
    }

    return content;
  }

  render() {
    const { tagName: Tag } = this.props;
    return <Tag className="cp-bib-title">{this.renderTitle()}</Tag>;
  }
}

BibTitle.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  renderAsLink: PropTypes.bool,
  truncateCount: PropTypes.number,
  tagName: PropTypes.string,
  reciprocalRank: PropTypes.number
};

BibTitle.defaultProps = {
  tagName: 'h1'
};

export default BibTitle;
